import { t } from '../../app/i18n';

export default {
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
};

export const translation = {
  ACTIVE: t('Aktívna'),
  CLOSED: t('Uzavretá'),
};



// WEBPACK FOOTER //
// ./src/common/enums/investmentStatus.js